import React from "react";

import styles from "./Divider.module.scss";

type DividerProps = {
  width?: number | string;
  height?: number | string;
  marginVertical?: number;
  marginHorizontal?: number;
};

const DividerComponent = ({
  width,
  height = 1,
  marginVertical = 0,
  marginHorizontal = 0,
}: DividerProps): JSX.Element => {
  return (
    <div
      className={styles.divider}
      style={{
        width,
        height,
        minHeight: height,
        margin: `${marginVertical}px ${marginHorizontal}px`,
      }}
    />
  );
};

export const Divider = React.memo(DividerComponent);
